module.exports = {"220524100":"柳河镇","220524101":"三源浦朝鲜族镇","220524102":"五道沟镇","220524103":"驼腰岭镇","220524104":"孤山子镇","220524105":"圣水河子镇","220524106":"罗通山镇","220524107":"安口镇","220524108":"向阳镇","220524109":"红石镇","220524110":"凉水河子镇","220524111":"亨通镇","220524200":"柳南乡","220524201":"时家店乡","220524202":"姜家店朝鲜族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220524.json
// module id = 588
// module chunks = 0